module.exports = __webpack_public_path__ + "static/img/06.7cda06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour2/06.jpg
// module id = keWZ
// module chunks = 0